module.exports = __webpack_public_path__ + "images/般蓝pr长图04-2.jpg?v=7d5a9f0d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图04-2.jpg
 ** module id = 173
 ** module chunks = 1 2
 **/